import $ from 'jquery';
import resetForm from '../utils/reset-form';

export default function inquireForm() {
  const $forms = $('.js-inquire-form');

  if (!$forms.length) return;

  $forms.each(function () {
    const $form = $(this);

    $form.find('[name="Handling"]').on('change', function () {
      const dataFields = $(this).data('fields');

      $form.find('.js-additional-fields').removeClass('is-active');
      $form.find(`.js-additional-fields[data-fields="${dataFields}"]`).addClass('is-active');
    });

    $form.find('[name="ContactType"]').on('change', function (e) {
      $form.removeClass('hcp patient');

      if (e.target.value === 'Patient') {
        $form.addClass('patient');
      } else {
        $form.addClass('hcp');
      }
    });

    $form.on('submit', function (e) {
      e.preventDefault();

      if ( !$form.valid() ) return;

      $.post('/process/usinfoform.php', $form.serialize(), () => {
        $form.closest('.medical-inquiry-modal, .js-form-container').addClass('complete');
      });
    });
  });

  $('.js-inquire-redo-btn').on('click', function() {
    $('.medical-inquiry-modal, .js-form-container').removeClass('complete');

    // Reset form
    const $form = $(this).closest('.js-form-container').find('.js-inquire-form');
    resetForm($form);
  });
}


// WEBPACK FOOTER //
// ./src/assets/js/project/inquire-form.js